// extracted by mini-css-extract-plugin
module.exports = {"message":"item_message__36zM0"};